//Module Keys
let locales = {
    vidfleet_search_by_esn: "Search by esn",
    vidfleet_last: "Last",
    vidfleet_range: "Range",
    vidfleet_apply: "Apply",
    vidfleet_warning_time: "Warning Time",
    vidfleet_camera_sm: "Camera ESN",
    vidfleet_warning: "Warning",
    vidfleet_maintenance_warnings: "VidFleet Warnings",
    vidfleet_maintenance_warnings_details: "Details",
    vidfleet_maintenance_warnings_view_details: "View Details",
    vidfleet_events: "Events",
    vidfleet_the_esn_could_not_be_consulted: "The esn could not be consulted",
    vidfleet_the_esn_does_not_exist: "The esn does not exist",
    vidfleet_error_maintenance_warnings: "No maintenance warning has been obtained due to error",
    vidfleet_uploaded_time: "Uploaded Time",
    vidfleet_request_time: "Request Time",
    vidfleet_description: "Description",
    vidfleet_error_camera_logs: "No camera logs has been obtained due to error",
    vidfleet_camera_logs: "Camera Logs",
    vidfleet_previous_status: "Previous Status",
    vidfleet_current_status: "Current Status",
    vidfleet_change_time: "Change Time",
    vidfleet_error_dms_statuses: "No DMS Statuses has been obtained due to error",
    vidfleet_dms_statuses: "DMS Statuses",
    vidfleet_created_time: "Created Time",
    vidfleet_power_off_time: "Power Off Time",
    vidfleet_recover_time: "Recover Time",
    vidfleet_error_power_lost: "No power lost has been obtained due to error",
    vidfleet_power_lost: "Power Lost",
    vidfleet_change_time: "Change Time",
    vidfleet_error_sd_card_status: "No sd card status has been obtained due to error",
    vidfleet_sd_card_status: "SD Card Status",
    vidfleet_account: "Account",
    vidfleet_device_name: "Device Name",
    apply_lang: "Apply",
    vidfleet_device_model: "Device Model",
    vidfleet_created_at: "Created At",
    vidfleet_white_listed_devices_error: "No white listed devices has been obtained due to error",
    vidfleet_white_listed_devices: "White Listed Devices",  
    vidfleet_show_vidfleet_info: "Show Vidfleet Info",  
    vidfleet_warning_type: "Warning Type",
    vidfleet_warning_account: "Account",
    vidfleet_warning_liked_unit: "Paired Device",
    vidfleet_warning_liked_unit_name: "Paired Device Name",
    vidfleet_warning_model: "Camera Model",
    vidfleet_maintenance: "Maintenance",
    vidfleet_user: "User",
    apply: "Apply",
    Apply_lang: "Apply",
    vidfleet_warning: "Warnings",
    vidfleet_reason: "Reason",
    vidfleet_poweredBy : "Powered By",
    vidfleet_lastGpsData : "Last Gps Data",
    vidfleet_firmwares_reviews: "Firmwares",
};

//Merge Views
import vidFleetConfiguration from 'Modules/vidfleet/.components/configuration/lan/en';
import restrictionsModal from 'Modules/vidfleet/.components/restrictionsModal/lan/en';
import cloneSettingsModal from 'Modules/vidfleet/.components/cloneSettingsModal/lan/en';
import vidFleetConfigurationUploadMode from 'Modules/vidfleet/.components/configurationUploadMode/lan/en';
import showChangesHistory from 'Modules/vidfleet/.components/showChangesHistory/lan/en';
import vidFleetConfigurationHubSpot from 'Modules/vidfleet/.components/configurationHubSpot/lan/en';
import configurationPreview from 'Modules/vidfleet/.components/configurationPreview/lan/en'

locales = { ...locales, ...vidFleetConfiguration, ...restrictionsModal, ...cloneSettingsModal, ...vidFleetConfigurationUploadMode, ...showChangesHistory, ...vidFleetConfigurationHubSpot, ...configurationPreview };

export default locales;











